import { createContext, useContext } from "react";
import "./styles.scss";

const TabContext = createContext();

const useTabContext = () => {
  const context = useContext(TabContext);
  if (!context) {
    throw new Error("Tab components must be used within Tab");
  }
  return context;
};

export const Tab = ({ onTabChange, value, children }) => {
  return (
    <TabContext.Provider value={{ onTabChange, value }}>
      {children}
    </TabContext.Provider>
  );
};

const TabList = ({ children }) => {
  return <div className="tab-list">{children}</div>;
};
const TabItem = ({ children, value, index }) => {
  const { onTabChange, value: selectedValue } = useTabContext();

  const isFirst = index === 0;
  const isActive = selectedValue?.index === index;
  const isAfter = index === selectedValue?.index + 1;

  const isHidden = isFirst || isActive || isAfter;

  return (
    <div className="tab-item-wrapper">
      <span className={`divider ${isHidden ? "hidden" : ""}`} />
      <div
        className={`tab-item ${
          selectedValue?.value === value ? "tab-item--active" : ""
        }`}
        onClick={() => onTabChange({ value, index })}
      >
        {children}
      </div>
    </div>
  );
};

Tab.List = TabList;
Tab.Item = TabItem;

export default Tab;
